import { render, staticRenderFns } from "./Expired.vue?vue&type=template&id=1deb6fb9&scoped=true&"
import script from "./Expired.vue?vue&type=script&lang=js&"
export * from "./Expired.vue?vue&type=script&lang=js&"
import style0 from "./Expired.vue?vue&type=style&index=0&id=1deb6fb9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deb6fb9",
  null
  
)

export default component.exports